import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class ContextIdService
{
	private readonly storageKey = 'contextId';
	private contextIdSubject: BehaviorSubject<string | null>;
	constructor( )
	{
	// Initialize the subject with the current sessionStorage value
    const initialContextId = sessionStorage.getItem(this.storageKey);
    this.contextIdSubject = new BehaviorSubject<string | null>(initialContextId);

    // Listen for `storage` event to update for cross-tab changes
    window.addEventListener('storage', this.handleStorageEvent.bind(this));
	}
  // Get an observable for contextId updates
     getContextIdObservable(): Observable<string | null> {
       return this.contextIdSubject.asObservable();
     }

     // Update contextId both in BehaviorSubject and sessionStorage
     setContextId(newContextId: string): void {
       sessionStorage.setItem(this.storageKey, newContextId);
       this.contextIdSubject.next(newContextId); // Emit to all subscribers
     }

     // Clear contextId and update BehaviorSubject
     clearContextId(): void {
       sessionStorage.removeItem(this.storageKey);
       this.contextIdSubject.next(null); // Emit null to subscribers
     }

     // Cleanup event listener (e.g., if service is destroyed, which is unlikely in app-wide scope)
     ngOnDestroy(): void {
       window.removeEventListener('storage', this.handleStorageEvent.bind(this));
     }

     // Handle `storage` event from other tabs/windows
     private handleStorageEvent(event: StorageEvent): void {
       if (event.storageArea === sessionStorage && event.key === this.storageKey) {
         this.contextIdSubject.next(event.newValue); // Emit updated value to subscribers
       }
     }




     contextId() : string | null {
        return sessionStorage.getItem(this.storageKey);
     }

}
